import React from 'react'
import PropTypes from 'prop-types'
import { DataPreview, Skeleton, Grid, Cell } from '@fs/zion-ui'

export default function DashboardBody({ children, columnCounts, loading }) {
  return (
    <>
      <DataPreview.Loading loading={loading}>
        <Grid>
          {columnCounts.map((count) => {
            return (
              <Cell key={Math.random()} columns={count}>
                <Skeleton.Paragraph lineCount={10} maxWidth={2000} size="md" />
              </Cell>
            )
          })}
        </Grid>
      </DataPreview.Loading>
      <DataPreview.Ready loading={loading}>
        <div>{children}</div>
      </DataPreview.Ready>
    </>
  )
}

DashboardBody.propTypes = {
  children: PropTypes.node,
  columnCounts: PropTypes.arrayOf(PropTypes.number),
  loading: PropTypes.bool,
}
